import { Link } from "react-router-dom";

const Demo4Hero4 = () => {
  return (
    <section
      id="hero-4"
      className="bg-scroll hero-section division"
      style={{ position: "relative", overflow: "hidden" }}
    >
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      >
        <source
          src="https://www.cigbusinesssetup.ae/wp-content/uploads/2025/07/6006201_Person_People_1280x720.mp4"
          type="video/mp4"
        />
      </video>
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          // background: "rgba(0, 0, 0, 0)",
          zIndex: 1,
        }}
      />
      <div className="container" style={{ position: "relative", zIndex: 2 }}>
        <div className="row">
          {/* HERO TEXT */}
          <div className="col-md-8 col-lg-6">
            <div className="hero-txt white-color1">
              {/* Title */}
              <h2 className="h2-md">
                <span> Start Your Business in the UAE</span>
              </h2>
              {/* Text */}
              <p className="p-md">
                Affordable Cost-Effective Company Setup Solutions for Startups!
              </p>
              {/* Button */}
              <Link
                to="/site/packages"
                type="button"
                className="btn btn-md btn-rose tra-white-hover "
              >
                Customize Your packages
              </Link>
            </div>
          </div>
        </div>
        {/* End row */}
      </div>
      {/* End container */}
    </section>
  );
};

export default Demo4Hero4;
